// extracted by mini-css-extract-plugin
export var externalLink = "_8w-0";
export var internalLinkLabel = "_8w-1";